module.exports = __webpack_public_path__ + "img/couples-075.21cd715a.jpg";